var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-facebook 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 18.5C21 19.881 19.881 21 18.5 21H5.5C4.1195 21 3 19.881 3 18.5V5.5C3 4.119 4.1195 3 5.5 3H18.5C19.881 3 21 4.119 21 5.5V18.5Z",
    fill: "#3F51B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.184 12.5H15.5V19H13V12.5H11.5V10.5H13V9.295C13.001 7.541 13.7295 6.5 15.796 6.5H17.5V8.5H16.3565C15.552 8.5 15.5 8.8 15.5 9.3615V10.5H17.5L17.184 12.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1ec3312cc2c9e7256005c1c376d60847.svg";
export { ForwardRef as ReactComponent };